import { FinanceLabField, getFinanceLabMetrics } from "@/entities/FinanceLab";
import { useApiQuery } from "@/api";
import clsx from "clsx";
import { useColorizedValue, DataSource } from "../hooks/useColorizedValue";
import { getLastValue } from "@/utils/metrics/metricsUtils";
import { ExpandableMarkdown } from "./ExpandableMarkdown";
import { LabelLLM } from "./LabelLLM";
import { useAtomValue } from "jotai";
import { showDataSourcesAtom } from "../state";

export function TransactionSummary() {
    const { data: summary } = useApiQuery(getFinanceLabMetrics, {
        params: {
            labels: [FinanceLabField.DEAL_TRANSACTION_SUMMARY],
        },
    });
    const showDataSources = useAtomValue(showDataSourcesAtom);

    const summaryColorized = useColorizedValue(
        getLastValue(summary?.[0]?.values)?.formattedValue || "-",
        DataSource.FINANCE_LAB,
        FinanceLabField.DEAL_TRANSACTION_SUMMARY,
    );

    return (
        <div>
            <div className="mb-2">
                <ExpandableMarkdown
                    text={summaryColorized.value}
                    maxLength={1800}
                />
            </div>
            {showDataSources && summaryColorized.source && (
                <span
                    className={clsx(
                        "mt-1 text-[9px] tracking-wide",
                        summaryColorized.sourceClassName,
                    )}
                >
                    {summaryColorized.source}
                </span>
            )}

            <LabelLLM />
        </div>
    );
}
